import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const DateAndTimeIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M7 17.501H3.152a.66.66 0 0 1-.652-.667V4.168a.66.66 0 0 1 .652-.667h13.696a.66.66 0 0 1 .652.667V8M5.5 2v3M14.5 2v3M2.5 7.501h15"
            />
            <circle cx={16} cy={17} r={6.5} stroke="currentColor" />
            <path stroke="currentColor" d="M15.5 13v5.5L18 20" />
        </svg>
    </IconWrapper>
)
